import { Injectable } from "@angular/core";
import { APIRoutes } from "../../../../shared/constants/api-routes.constant";
import { BaseWebService } from "../../../../shared/services/base.service";

import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { OAuthService } from "../../../user/services/oauth.service";

@Injectable()
export class OrganizacaoWebService extends BaseWebService<any> {
  constructor(http: HttpInterceptor, oauthService: OAuthService) {
    super(APIRoutes.ORGANIZACAO, http, oauthService);
  }
}
